import { render, staticRenderFns } from "./MailVerify.vue?vue&type=template&id=a1835ad0&scoped=true"
import script from "./MailVerify.vue?vue&type=script&lang=js"
export * from "./MailVerify.vue?vue&type=script&lang=js"
import style0 from "./MailVerify.vue?vue&type=style&index=0&id=a1835ad0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1835ad0",
  null
  
)

export default component.exports